import { useState, useEffect, useContext, useRef } from 'react'
import { useTranslation } from "react-i18next";

import { Input, SelectBox, ClassesDropdown, RichText, UploadForm } from '../Form'

import './css/pop.css'

export default function imgInput({ setOpen, Open, onChange }) {

    const { t } = useTranslation();
    const [values, setvalues] = useState(false);
    
    function save(val) {
        
        if (val[0]) {
            onChange({ type: Open, value:val });
            setOpen(false);
        }
        
        
    }

    return (
        <div tabindex="-1" className='tiny_pop Img'>
            
            <div className='tiny_body'>
                <h3>{t("task_type_4")}</h3>

                <UploadForm
                    boxClass="imgCenterUpload"
                    onChange={(d) => save(d)}
                    value={[]}
                    accept=".jpg,.jpeg,.png,.gif"
                /> 

                <div style={{display:"flex", justifyContent:"end", gap:5, padding:20}}>
                    <button onClick={(d) => setOpen(false)} className='btn green'>{t("cancel")}</button>

                </div>
            </div>

            

        </div>
    );
}